import { CoolDialogService } from '@angular-cool/dialogs';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ControlReportGenerateRequestDTO } from '../../../../../../../server/src/dto/control-report.dto';
import { DepartmentDTO } from '../../../../../../../server/src/dto/department.dto';
import { LearningReportGenerateRequestDTO } from '../../../../../../../server/src/dto/learning-reports.dto';
import { ReportDTO } from '../../../../../../../server/src/dto/report.dto';
import { ReportStatus } from '../../../../../../../server/src/models/report-type.enum';
import { RouteNavigationService } from '../../../../shared/routing/route-navigation.service';
import { WINDOW } from '../../../../shared/services/injection-tokens';
import { LanguageService } from '../../../../shared/services/language/language.service';
import { LearningReportService } from '../shared/services/learning-report.service';
import { LearningReportGenerateDialogComponent } from './learning-report-generate-dialog/learning-report-generate-dialog.component';

@Component({
  selector: 'app-learning-reports-list',
  templateUrl: './learning-reports-list.component.html',
  styleUrls: ['./learning-reports-list.component.scss'],
})
export class LearningReportsListComponent implements OnInit {
  constructor(private _reportsService: LearningReportService,
              private _routeNavigationService: RouteNavigationService,
              private _languageService: LanguageService,
              private _coolDialogService: CoolDialogService,
              @Inject(WINDOW) private _window: Window,
              private _dialogService: MatDialog) {
  }

  public displayedColumns = ['learningCampaign', 'startDate', 'endDate', 'departments', 'status', 'actions'];
  public isLoading: boolean;

  public dataSource: MatTableDataSource<ReportDTO<LearningReportGenerateRequestDTO>>;

  @ViewChild(MatSort, { static: true })
  public sort: MatSort;

  public ReportStatus = ReportStatus;

  public async ngOnInit() {
    await this.loadDataAsync();
  }

  public async addReportAsync() {
    const dialog = this._dialogService.open(LearningReportGenerateDialogComponent);

    await dialog.afterClosed().toPromise();

    await this.loadDataAsync();

    setTimeout(async () => {
      await this.loadDataAsync();
    }, 1000 * 30);

    setTimeout(async () => {
      await this.loadDataAsync();
    }, 1000 * 60);

    setTimeout(async () => {
      await this.loadDataAsync();
    }, 1000 * 60 * 1.5);
  }

  public downloadReport(report: ReportDTO<ControlReportGenerateRequestDTO>) {
    this._window.open(report.reportFileUrl, '_blank');
  }

  public async deleteReportAsync(report: ReportDTO<ControlReportGenerateRequestDTO>) {
    const removeDialogResult = await this._coolDialogService.showDialog({
      titleText: await this._languageService.getTranslationAsync('Dashboard.ReportsCommon.RemoveReportTitle'),
      questionText: await this._languageService.getTranslationAsync('Dashboard.ReportsCommon.RemoveReportDescription'),
      confirmActionButtonText: await this._languageService.getTranslationAsync('Common.Remove'),
      cancelActionButtonText: await this._languageService.getTranslationAsync('Common.Cancel'),
      confirmActionButtonColor: 'warn',
    });

    if (!removeDialogResult.isConfirmed) {
      return;
    }

    await this._reportsService.deleteReportByIdAsync(report.id);

    await this.loadDataAsync();
  }

  public async viewReportAsync(report: ReportDTO<LearningReportGenerateRequestDTO>) {
    await this._routeNavigationService.goToViewLearningReportAsync(report.id);
  }

  public async loadDataAsync() {
    try {
      this.isLoading = true;

      const reports = await this._reportsService.getReportsAsync();

      this.dataSource = new MatTableDataSource(reports);
      this.dataSource.sort = this.sort;
    } finally {
      this.isLoading = false;
    }
  }

  public getDepartmentColumn(departments: DepartmentDTO[]): string {
    return departments.map(d => d.name).join(', ');
  }
}
